import type { SagaIterator } from "redux-saga";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { getType } from "typesafe-actions";

import * as treeApi from "@/shop/api/tree";

import * as TreeActions from "./actions";
import type { TreeAction } from "./reducer";
import { getPartTreeExists } from "./selectors";
import type { ITreeStructure } from "../../types/tree";

function* fetchTree(action: TreeAction): SagaIterator {
  const { url } = action.payload;
  try {
    // check if we already fetched the tree
    const treeExists = (yield select(getPartTreeExists, url)) as boolean;

    if (treeExists) {
      return;
    }

    // flag the tree as fetching
    yield put(TreeActions.fetchTreeStart(url));

    // call the api to retrieve the session
    const treeData = (yield call(treeApi.fetchTree, url)) as ITreeStructure;

    // put action to save data in state
    yield put(TreeActions.fetchTreeSuccess({ url, tree: treeData }));
  } catch {
    // fetch failed, handle the error
    yield put(TreeActions.fetchTreeFail(url));
  }
}

export default function* treeSaga(): SagaIterator {
  yield takeEvery(getType(TreeActions.fetchTree), fetchTree);
}
